import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-referredbooks',
  templateUrl: './referredbooks.component.html',
  styleUrls: ['./referredbooks.component.scss'],
  providers:[LibraryService],
})
export class ReferredbooksComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private smallmodalRef: NgbModalRef;
  fserdt:any;
  fserdt4:any;
  objdet:any={};
  arrrefbooks:any=[];
  dashcounts=[];
   
  data = [
    {
      id: 1,
      name: 'Usa'
    },
    {
      id: 2,
      name: 'England'
    }
 ];

 constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {

  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
  }
  this.setfirstdate();
 }


 open(content,cmd,obj) {
   console.log(obj);
  this.modalOptions = {
   
    size:'md'
   
  }
  if(cmd=='insert')
  {
    this.objdet={};
    this.objdet.rid=0;
    this.objdet.oprtype='insert';

  }
  else if(cmd=='update')
  {
    this.objdet=obj;
    this.objdet.oprtype='update';

  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
    
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        
    });
}

openedit(content,cmd,obj) {
  console.log(obj);
 this.modalOptions = {
  
  
  
 }
 if(cmd=='insert')
 {
   this.objdet={};
   this.objdet.rid=0;
   this.objdet.oprtype='insert';

 }
 else if(cmd=='update')
 {
   this.objdet=obj;
   this.objdet.oprtype='update';

 }
 this.modalRef=this.modalService.open(content,this.modalOptions);
   
 this.modalRef.result.then((result) => {

      // this.Asmtdetls(asid);
       this.closeResult = `Closed with: ${result}`;
   }, (reason) => {
       
   });
}

SaveDetails()
{
  console.log('catsave',this.objdet);
  this.liservice.saverefbook(this.objdet)
      .subscribe(
      result => {
          console.log('SavesourceDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.getlibmperiodical('selwithsub');
           this.getrefbooks();
          }
       else  {

         }
      },
      error =>{ alert('Error While saving...');}
      )

}

getrefbooks() {
  this.liservice.getlibtbkref(this.fserdt,this.fserdt4)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
          this.arrrefbooks = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}

openlg(content) {
  this.modalOptions = {
   
    size:'lg'
   
  }
  this.modalService.open(content, this.modalOptions ).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

setfirstdate() {
  this.liservice.getsysdatetoday()
      .subscribe(
      resultArray => {
          console.log('getlibsource', resultArray);
          this.fserdt = resultArray;
          this.fserdt4 = resultArray;
          this.getrefbooks();
          
      },
      error => console.log("Error :: " + error)
      )
}

  getlibvisitordashcounts() {
    this.liservice.getlibvisitordashcounts('referinfo')
        .subscribe(
        resultArray => {
            console.log('getlibsupplier', resultArray);
            this.dashcounts = resultArray[0];
           
        },
        error => console.log("Error :: " + error)
        )
  }


private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}


  ngOnInit(): void {

    this.getlibvisitordashcounts();
  }

}
